if (!customElements.get('carousel-section')) {
	class CarouselSection extends HTMLElement {
		constructor() {
                  super();
                  this.carousel = "";
		}
		connectedCallback() {
                  console.log('func running')
                  this.carousel = Flickity.data(this) ?? "";

                  window.addEventListener('resize', () => {
                        console.log('window reized');
                        if (Flickity.data(this)) {
                              Flickity.data(this)?.resize();
                        }
                  })

		}
	}
	customElements.define('carousel-section', CarouselSection);
}
